import { Button, Typography } from "@mui/material";
import React from "react";

const CustomButton = ({
  children,
  variant,
  size,
  sx,
  color,
  disabled,
  fullWidth,
  startIcon,
  endIcon,
  onClick,
  type,
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      color={color}
      sx={{
        ...sx,
        // Disable ripple effect on mobile devices to prevent blue highlighting
        '@media (max-width: 768px)': {
          '&:focus': {
            outline: 'none',
          },
          '&:active': {
            backgroundColor: 'transparent',
          },
        },
      }}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      disableRipple={window.innerWidth <= 768} // Disable ripple on mobile
      disableFocusRipple={window.innerWidth <= 768} // Disable focus ripple on mobile
      disableTouchRipple={window.innerWidth <= 768} // Disable touch ripple on mobile
    >
      <Typography variant="body1">{children}</Typography>
    </Button>
  );
};

export default CustomButton;
